/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Actions_LabelInputs */



/**
* | output |
* | --- |
* | "Metadata actions" |
*
* @param {Event_Group_Metadata_Actions_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_actions_label = /** @type {((inputs?: Event_Group_Metadata_Actions_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Actions_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actions des métadonnées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Metadatenaktionen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Azioni sui metadati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Действия с метаданными")
	if (locale === "es") return /** @type {LocalizedString} */ ("Acciones de metadatos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("元数据操作")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メタデータアクション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेटाडेटा क्रियाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ações de metadados")
	return /** @type {LocalizedString} */ ("Metadata actions")
});